const ProjectTitle = ({ record }) => {
    return <span>Project {record ? `"${record.name}"` : ''}</span>;
};

export default ProjectTitle;